export const PENDING_STATUS = 'pending' as const;
export const SUCCESS_STATUS = 'success' as const;
export const FAILURE_STATUS = 'failure' as const;

export const PENDING = 'pending' as const;
export const SUCCESS = 'success' as const;
export const FAILURE = 'failure' as const;

export const STATUS = {
    PENDING_STATUS,
    SUCCESS_STATUS,
    FAILURE_STATUS
}